import { GET_ALL_RECORDS } from "../domain/constants";
import { SubscriptionType } from "../domain/enums/SubscriptionTypeEnum";
import {
    SubscriptionCreationForm,
    SubscriptionDTO,
} from "../domain/models/dto/SubscriptionDTO";
import { SubscriptionSettings } from "../domain/models/SubscriptionSettings";
import { EasyPayNewOrderDTO } from "../integrations/easypay/interfaces/EasyPayDTO";
import { CollectionResponse, SimpleResponse } from "../types/ApiResults";
import { ApiServiceImpl, createAsyncThunkFactory } from "./ApiServiceImpl";

export class SubscriptionServiceImpl extends ApiServiceImpl {
    private constructor() {
        super();
    }

    static createSubscriptionThunk = createAsyncThunkFactory<
        SubscriptionDTO | EasyPayNewOrderDTO,
        SubscriptionCreationForm
    >("SubscriptionServiceImpl.createSubscription", async (args) => {
        return this.post("/api/v1/subscription", args);
    });

    static getAllSubscriptionsThunk = createAsyncThunkFactory<
        CollectionResponse<SubscriptionDTO>,
        null
    >("SubscriptionServiceImpl.getAllSubscriptions", async () => {
        return this.getCollection("/api/v1/subscription", {
            page: GET_ALL_RECORDS,
            limit: 1,
            offset: 1,
        });
    });

    static changeSubscriptionAutoActivationThunk = createAsyncThunkFactory<
        SimpleResponse,
        null
    >("SubscriptionServiceImpl.changeSubscriptionAutoActivation", async () => {
        return this.patch(`/api/v1/subscription/auto-activation`, {});
    });

    static getSubscriptionSettingsThunk = createAsyncThunkFactory<
        SubscriptionSettings,
        SubscriptionType
    >("SubscriptionServiceImpl.getSubscriptionSettings", async (type) => {
        const params = new URLSearchParams({ type } as any);
        return this.get(`/api/v1/subscription/settings?${params.toString()}`);
    });
}
